<template>
  <main class="lot-search">
    <h1>{{$t(title)}}</h1>
    <section class="procurement a-main-content">
      <div class="procurement__liner">
        <div class="procurement__container-button">
          <router-link class="gui-btn gui-btn--collapse"
                       active-class="gui-btn--collapse--active"
                       :to="{name: 'home-search', params: { search: 'active' }}"
                       v-t="'form.public-search.tabs.active'">
          </router-link>
          <router-link class="gui-btn gui-btn--collapse"
                       active-class="gui-btn--collapse--active"
                       :to="{name: 'home-search', params: { search: 'archive' }}"
                       v-t="'form.public-search.tabs.archive'">
          </router-link>
        </div>
      </div>
      <div class="procurement__container">
        <router-view/>
      </div>
    </section>
  </main>
</template>

<script>
  import _ from 'lodash';

  export default {
    computed: {
      title() {
        return _.get(_.findLast(this.$route.matched, 'meta.title'), 'meta.title');
      },
    }
  }
</script>

<style scoped>

</style>
